var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8405_18450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 9.31506C18 13.8073 14.7087 17.5307 10.4062 18.2057V11.9166H12.5033L12.9023 9.31506H10.4062V7.62686C10.4062 6.91495 10.755 6.22131 11.873 6.22131H13.0078V4.00647C13.0078 4.00647 11.9777 3.83069 10.993 3.83069C8.93742 3.83069 7.59375 5.07663 7.59375 7.33225V9.31506H5.30859V11.9166H7.59375V18.2057C3.29133 17.5307 0 13.8073 0 9.31506C0 4.34467 4.02961 0.315063 9 0.315063C13.9704 0.315063 18 4.34467 18 9.31506Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5033 11.9166L12.9023 9.31506H10.4062V7.62683C10.4062 6.91509 10.7549 6.22131 11.8729 6.22131H13.0078V4.00647C13.0078 4.00647 11.9779 3.83069 10.9932 3.83069C8.93739 3.83069 7.59375 5.07663 7.59375 7.33225V9.31506H5.30859V11.9166H7.59375V18.2057C8.05198 18.2776 8.52159 18.3151 9 18.3151C9.47841 18.3151 9.94802 18.2776 10.4062 18.2057V11.9166H12.5033Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8405_18450"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.315063)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/facebook-logo.5cb04b2851aadf2f88506a9948d17f24.svg";
export { ForwardRef as ReactComponent };